import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  LuBadgePercent,
  LuChevronDown,
  LuChevronRight,
  LuFileText,
  LuLogOut,
  LuNetwork,
  LuShieldCheck,
  LuUserRoundCheck,
  LuUserRoundCog,
  LuWallet,
  LuUsers,
  LuUserRoundCog as LuSubIb,
} from "react-icons/lu";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";
import { LogoutApi } from "../../../api/request/users.js";
import { setloggedIn } from "../../../store/Slices/userSlice.js";
import { removeCookies } from "../../../services/Cookies.jsx";

const IBSettingsMobile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reportsExpanded, setReportsExpanded] = useState(false);

  const menuItems = [
    
    {
      id: "kyc_manager",
      title: "KYC",
      icon: <LuUserRoundCheck className="text-gray-500" />,
      hasArrow: true,
      url: "/ib/kyc_manager",
    },
    // {
    //   id: "ib_wallet",
    //   title: "IB Wallet",
    //   icon: <LuWallet className="text-gray-500" />,
    //   hasArrow: true,
    //   url: "/ib/withdraw",
    // },
    {
      id: "ib_manager",
      title: "IB Manager",
      icon: <LuUserRoundCog className="text-gray-500" />,
      hasArrow: true,
      url: "/ib/ib_manager",
    },
    // {
    //   id: "my_team",
    //   title: "My Team",
    //   icon: <LuUsers className="text-gray-500" />,
    //   hasArrow: true,
    //   url: "/ib/my_trader_team",
    // },
    {
      id: "ib_tree",
      title: "IB Tree",
      icon: <LuNetwork className="text-gray-500" />,
      hasArrow: true,
      url: "/ib/tree",
    },
    // {
    //   id: "commission",
    //   title: "Commission",
    //   icon: <LuBadgePercent className="text-gray-500" />,
    //   hasArrow: true,
    //   url: "/ib/commission",
    // },
    {
      id: "distribution",
      title: "Distribution",
      icon: <LuBadgePercent className="text-gray-500" />,
      hasArrow: true,
      url: "/ib/commission_distribute",
    },
    {
      id: "live_account",
      title: "Live Account",
      icon: <LuShieldCheck className="text-gray-500" />,
      hasArrow: true,
      url: "/ib/live_account",
    },
    {
      id: "reports",
      title: "Reports",
      icon: <LuFileText className="text-gray-500" />,
      hasArrow: false,
      isExpandable: true,
      children: [
        {
          id: "report_earning",
          title: "Earning",
          icon: <LuBadgePercent className="text-gray-500" />,
          url: "/ib/reports/earning",
        },
        {
          id: "report_withdraw",
          title: "Withdraw",
          icon: <LuWallet className="text-gray-500" />,
          url: "/ib/reports/withdraw",
        },
        {
          id: "report_my_team",
          title: "My Team",
          icon: <LuUsers className="text-gray-500" />,
          url: "/ib/reports/my_team",
        },
        {
          id: "report_my_sub_ib",
          title: "My Sub IB",
          icon: <LuSubIb className="text-gray-500" />,
          url: "/ib/reports/my_sub_ib",
        },
      ],
    },
    // {
    //   id: "support",
    //   title: "Support",
    //   icon: <LuFileText className="text-gray-500" />,
    //   hasArrow: true,
    //   url: "/ib/support",
    // },
    // {
    //   id: "promotion",
    //   title: "Promotion Kit",
    //   icon: <LuBadgePercent className="text-gray-500" />,
    //   hasArrow: true,
    //   url: "/ib/promotion",
    // },
  ];

  const handleMenuClick = (item) => {
    const url = item.url;
    if (url) {
      navigate(url);
      return;
    }
    switch (item.id) {
      case "kyc_manager":
        navigate("/ib/kyc_manager");
        break;
      case "ib_manager":
        navigate("/ib/ib_manager");
        break;
      case "ib_tree":
        navigate("/ib/tree");
        break;
      case "commission":
        navigate("/ib/commission");
        break;
      case "distribution":
        navigate("/ib/commission_distribute");
        break;
      case "live_account":
        navigate("/ib/live_account");
        break;
      case "dashboard":
        navigate("/ib/dashboard");
        break;
      case "ib_wallet":
        navigate("/ib/withdraw");
        break;
      case "my_team":
        navigate("/ib/my_trader_team");
        break;
      case "support":
        navigate("/ib/support");
        break;
      case "promotion":
        navigate("/ib/promotion");
        break;
      default:
        break;
    }
  };

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi();
      if (data?.success) {
        toast.success(data?.message);
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsModalOpen(false);
      setIsLoading(false);
    } catch (err) {
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsModalOpen(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="min-h-screen">
        <div className="space-y-3 mb-8">
          {menuItems.map((item) => (
            <div key={item.id}>
              <div
                className="bg-white rounded-lg p-4 py-3 cursor-pointer border border-gray-100 shadow-sm"
                onClick={() =>
                  item.isExpandable
                    ? setReportsExpanded((prev) => !prev)
                    : handleMenuClick(item)
                }
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <div className="h-10 w-10 grid place-items-center bg-gray-100 rounded-[14px]">
                      {item.icon}
                    </div>
                    <span className="font-medium">{item.title}</span>
                  </div>

                  {item.isExpandable && (
                    <button className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-[10px] transition-colors">
                      <LuChevronDown
                        className={`text-gray-500 transition-transform duration-300 ${
                          reportsExpanded ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  )}

                  {item.hasArrow && !item.isExpandable && (
                    <button
                      className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-[10px] transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMenuClick(item);
                      }}
                    >
                      <LuChevronRight className="text-gray-500" />
                    </button>
                  )}
                </div>
              </div>

              {item.isExpandable && reportsExpanded && (
                <div className="mt-2 space-y-3">
                  {item.children.map((child) => (
                    <div
                      key={child.id}
                      className="bg-white rounded-lg p-4 py-3 cursor-pointer border border-gray-100 shadow-sm"
                      onClick={() => navigate(child.url)}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="h-10 w-10 grid place-items-center bg-gray-100 rounded-[14px]">
                            {child.icon}
                          </div>
                          <span className="font-medium">{child.title}</span>
                        </div>
                        <button className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-[10px] transition-colors">
                          <LuChevronRight className="text-gray-500" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mb-8">
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors flex items-center justify-center space-x-2"
          >
            <LuLogOut />
            <span>Logout</span>
          </button>
        </div>
      </div>

      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        message="Are you sure you want to logout?"
        onConfirm={handleLogout}
        isLoading={isLoading}
        loadingLabel="Logging out..."
      />
    </>
  );
};

export default IBSettingsMobile;
